import axios from '@/lib/AxApi';

export default
{
  async selectRow(params, cb)
  {
    try
    {
      var response = await axios.get('/QuizPages/selectRow',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async submitData(params, cb)
  {
    try
    {
      var func = 'insertRow';
      if (typeof params.id != 'undefined' && params.id != '') func = 'updateRow';

      var response = await axios.post('/QuizPages/' + func, params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async deleteRow(params, cb)
  {
    try
    {
      var response = await axios.post('/QuizPages/deleteRow', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async deleteAll(params, cb)
  {
    try
    {
      var response = await axios.post('/QuizPages/deleteAll', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async updateOrderNum(params, cb)
  {
    try
    {
      var response = await axios.post('/QuizPages/updateOrderNum', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  }
}
